import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { LinearProgress } from "@material-ui/core";
import Axios from "axios";
import { connect } from "react-redux";
import { Divider, TextField, Button } from "@material-ui/core";

import Visibility from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

import { useStyles } from "./AddAuthor.css";
import { url } from "../../../../config/config";
import NavBar from "../../../../Component/NavBar/AdminHeader/AdminHeader";
import AdminPageTitle from "../../../../Component/AdminPageTitle/AdminPageTitle";
import FormLoader from "../../../../Component/FormLoader/FormLoader";

const CustomLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
  },
}))(LinearProgress);

class AddAuthor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        firstName: "",
        middleName: "",
        lastName: "",
        phone: "",
        url: "",
        description: "",
        email: "",
        password: "",
      },
      percentage: 0,
      emailError: "",
      phoneError: "",
      firstNameError: "",
      profileImage: [],
      lastNameError: "",
      descriptionError: "",
      passwordError: "",
      showPassword: false,
      success: "",
      loading: false,
    };
  }

  componentDidMount() {
    if (this.props.editStatus) {
      this.getData();
    }
  }

  getData = async () => {
    try {
      const response = await Axios.get(
        `${url}/api/authors/${this.props.match.params.authorId}`
      );
      this.setState({
        data: {
          firstName: response.data.firstName,
          middleName: response.data.middleName,
          lastName: response.data.lastName,
          email: response.data.email,
          phone: response.data.phone,
          description: response.data.description,
          url: response.data.imageUrl,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  handleChange = (e) => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });
  };

  handleShowPassword = (e) => {
    if (e.target.value === "true") {
      this.setState({
        ...this.state,
        [e.target.name]: true,
      });
    } else {
      this.setState({
        ...this.state,
        [e.target.name]: false,
      });
    }
  };

  handleUpload = (e) => {
    let reader = new FileReader();
    this.setState({
      data: { ...this.state.data, profileImage: e.target.files[0] },
    });
    let files = e.target.files[0];
    reader.onload = (e) => {
      this.setState({
        data: {
          ...this.state.data,
          url: e.target.result,
        },
      });
    };

    reader.onprogress = (data) => {
      if (data.lengthComputable) {
        var progress = parseInt((data.loaded / data.total) * 100, 10);
        this.setState({
          percentage: progress,
        });
      }
    };

    if (files) {
      reader.readAsDataURL(files);
    }
  };

  checkError = (EmailError, PhoneError) => {
    let emailError = EmailError;
    let firstNameError = "";
    let lastNameError = "";
    let phoneError = PhoneError ? "Use Only Numbers" : "";
    let descriptionError = "";
    let passwordError = "";

    if (this.state.data.firstName.length < 3) {
      firstNameError = "First Name must be minimum of 3 characters";
    }
    if (this.state.data.lastName.length < 3) {
      lastNameError = "Last Name must be minimum of 3 characters";
    }
    if (this.state.data.phone.length < 10) {
      phoneError = "Phone Number must be of minimum length 10";
    }
    if (this.state.data.description.length < 3) {
      descriptionError = "Description must be of minimum length 3";
    }

    if (!this.props.editStatus) {
      if (this.state.data.password.length < 8) {
        passwordError = "Password must be minimum of 8 characters";
      }
    }

    if (
      emailError ||
      firstNameError ||
      lastNameError ||
      phoneError ||
      descriptionError ||
      passwordError
    ) {
      this.setState({
        emailError,
        firstNameError,
        lastNameError,
        phoneError,
        descriptionError,
        passwordError,
      });
      return true;
    } else {
      this.setState({
        emailError: "",
        firstNameError: "",
        lastNameError: "",
        phoneError: "",
        descriptionError: "",
        passwordError: "",
      });
      return false;
    }
  };

  filterEditData = (data) => {
    let changedData = data;
    delete changedData.password;
    return changedData;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();

    if (errorStatus === false) {
      this.setState({ loading: true });
      let data = {
        firstName: this.state.data.firstName,
        middleName: this.state.data.middleName,
        lastName: this.state.data.lastName,
        email: this.state.data.email,
        phone: this.state.data.phone,
        password: this.state.data.password,
        description: this.state.data.description,
        imageUrl: this.state.data.url,
      };
      let response = [];
      if (this.props.editStatus) {
        let changedData = this.filterEditData(data);
        const response = await Axios.put(
          `${url}/api/authors/${this.props.authorId}`,
          changedData,
          {
            headers: {
              "x-auth-token": this.props.adminToken,
            },
          }
        );
        if (response.data.emailError || response.data.errors) {
          if (response.data.emailError) {
            this.checkError(response.data.emailError, "");
            this.setState({ loading: false });
          } else {
            this.checkError("", response.data.message);
            this.setState({ loading: false });
          }
        } else {
          if (response.data.success && errorStatus === false) {
            this.setState({ success: response.data.success });
            this.props.history.push("/_administration_/author/view");
          }
        }
      } else {
        response = await Axios.post(`${url}/api/authors`, data);
        if (response.data.emailError || response.data.errors) {
          if (response.data.emailError) {
            this.checkError(response.data.emailError, "");
            this.setState({ loading: false });
          } else {
            this.checkError("", response.data.message);
            this.setState({ loading: false });
          }
        } else {
          if (response.data.success && errorStatus === false) {
            this.setState({
              success: response.data.success,
            });
            this.props.history.push("/_administration_/author/view");
          }
        }
      }
    }
  };

  handleProgress = () =>
    this.state.percentage ? (
      <React.Fragment>
        <CustomLinearProgress
          value={this.state.percentage}
          variant="determinate"
        />
        {this.state.percentage === 100 ? (
          <React.Fragment>Upload Complete</React.Fragment>
        ) : (
          <React.Fragment>{this.state.percentage}%</React.Fragment>
        )}
      </React.Fragment>
    ) : null;

  showPassword = () => {
    return (
      <Visibility
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showPassword: true })}
      />
    );
  };

  hidePassword = () => {
    return (
      <VisibilityOffIcon
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showPassword: false })}
      />
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <NavBar />
        <div className={classes.root}>
          <AdminPageTitle title="Author List" />
          <Divider />
          <form onSubmit={this.handleSubmit}>
            <div
              style={{
                padding: 20,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {this.state.data.url && (
                <div style={{ width: 200, height: 200 }}>
                  <img
                    src={this.state.data.url}
                    alt="Author Profile"
                    style={{ width: 200, height: 200 }}
                  />
                </div>
              )}
            </div>
            <div
              style={{
                padding: 20,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <input
                type="file"
                id="imageUpload"
                style={{ display: "none" }}
                onChange={this.handleUpload}
              />
              <div>{this.handleProgress()}</div>
              <label htmlFor="imageUpload">
                <Button className={classes.buttonStyle} component="span">
                  Upload or edit image
                </Button>
              </label>
            </div>
            <TextField
              name="firstName"
              type="text"
              label="First Name"
              fullWidth
              required
              margin="normal"
              variant="outlined"
              style={{ outline: "none" }}
              placeholder="Enter author's first name"
              error={this.state.firstNameError ? true : false}
              helperText={this.state.firstNameError}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              className={classes.nameInputWithMargin}
              value={this.state.data.firstName}
              onChange={this.handleChange}
            />

            <TextField
              name="middleName"
              type="text"
              label="Middle Name"
              fullWidth
              margin="normal"
              variant="outlined"
              style={{ outline: "none" }}
              placeholder="Enter author's middle name"
              helperText="This is optional"
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              className={classes.nameInputWithMargin}
              value={this.state.data.middleName}
              onChange={this.handleChange}
            />

            <TextField
              name="lastName"
              type="text"
              label="Last Name"
              fullWidth
              required
              margin="normal"
              variant="outlined"
              style={{ outline: "none" }}
              placeholder="Enter author's last name"
              error={this.state.lastNameError ? true : false}
              helperText={this.state.lastNameError}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              className={classes.nameInputWithMargin}
              value={this.state.data.lastName}
              onChange={this.handleChange}
            />

            <TextField
              name="phone"
              type="tel"
              label="Phone Number"
              fullWidth
              required
              margin="normal"
              variant="outlined"
              style={{ outline: "none" }}
              placeholder="Enter author's phone number"
              error={this.state.phoneError ? true : false}
              helperText={this.state.phoneError}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              className={classes.nameInputWithMargin}
              value={this.state.data.phone}
              onChange={this.handleChange}
            />

            <TextField
              name="email"
              type="email"
              label="Email Address"
              fullWidth
              required
              margin="normal"
              variant="outlined"
              style={{ outline: "none" }}
              placeholder="Enter author's email address"
              error={this.state.emailError ? true : false}
              helperText={this.state.emailError}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              className={classes.nameInputWithMargin}
              value={this.state.data.email}
              onChange={this.handleChange}
            />
            {!this.props.editStatus && (
              <TextField
                name="password"
                type={this.state.showPassword ? "text" : "password"}
                label="Password"
                fullWidth
                required
                margin="normal"
                variant="outlined"
                style={{ outline: "none" }}
                placeholder="Enter password"
                error={this.state.passwordError ? true : false}
                helperText={this.state.passwordError}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                  endAdornment: this.state.showPassword
                    ? this.hidePassword()
                    : this.showPassword(),
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                className={classes.nameInputWithMargin}
                value={this.state.data.password}
                onChange={this.handleChange}
              />
            )}

            <TextField
              name="description"
              type="string"
              label="Bio"
              required
              multiline
              fullWidth
              margin="normal"
              rows={4}
              rowsMax={8}
              variant="outlined"
              placeholder="Enter author's bio"
              style={{ outline: "none" }}
              error={this.state.descriptionError ? true : false}
              helperText={this.state.descriptionError}
              InputProps={{
                classes: {
                  focused: classes.focused,
                  notchedOutline: classes.notchedOutline,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              value={this.state.data.description}
              onChange={this.handleChange}
            />

            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="submit"
                variant="outlined"
                className={classes.buttonStyle}
              >
                {this.props.editStatus ? "Update" : "Submit"}
              </Button>
              {this.state.loading && <FormLoader />}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(AddAuthor)));
